import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="sort"
export default class extends Controller {
  static targets = ['sortableItem']

  connect () {
    document.addEventListener('turbo:render', this.sort.bind(this))
    document.addEventListener('turbo:after-stream-render', this.sort.bind(this))
    this.sort()
  }

  disconnect () {
    document.removeEventListener('turbo:render', this.sort.bind(this))
    document.removeEventListener('turbo:after-stream-render', this.sort.bind(this))
  }

  sort () {
    const items = this.sortableItemTargets

    items.sort((a, b) => {
      const indexA = parseInt(a.dataset.sortindex)
      const indexB = parseInt(b.dataset.sortindex)
      return indexA - indexB
    })

    items.forEach((item) => {
      item.parentElement.appendChild(item)
    })
  }
}
